import { render, staticRenderFns } from "./RegistrosSegmentoCargaLiquida.vue?vue&type=template&id=65e96b17&scoped=true&"
import script from "./RegistrosSegmentoCargaLiquida.vue?vue&type=script&lang=js&"
export * from "./RegistrosSegmentoCargaLiquida.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosSegmentoCargaLiquida.vue?vue&type=style&index=0&id=65e96b17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e96b17",
  null
  
)

export default component.exports